(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-strip"] && !Shopify.designMode) return;
  try {
    (() => {
    const SELECTOR = '.card-strip[data-start], .card-strip[data-end]';

    const check = () => {
      const now = Date.now() / 1000;
      document.querySelectorAll(SELECTOR).forEach((strip) => {
        const start = Number(strip.dataset.start) || 0;
        const end = Number(strip.dataset.end) || Infinity;
        strip.hidden = !(now >= start && now < end);
      });
    };

    let queued = false;
    const queueCheck = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        check();
      });
    };

    const start = () => {
      check();
      new MutationObserver(queueCheck).observe(document.body, { childList: true, subtree: true });
      setInterval(check, 60000);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["job-application-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-japply]').forEach(function (root) {
    var form = root.querySelector('form');
    var statusEl = root.querySelector('[data-japply-status]');
    var doneEl = root.querySelector('[data-japply-done]');
    var submit = root.querySelector('.japply__submit');
    var fileInput = form.querySelector('input[type="file"]');
    var endpoint = root.dataset.endpoint;
    var maxBytes = (parseFloat(root.dataset.maxMb) || 4) * 1024 * 1024;

    // Stamped at render, sent on submit. The server rejects anything filled in
    // under three seconds — no human types their name that fast.
    var openedAt = Date.now();

    var MESSAGES = {
      bad_phone: 'צריך מספר נייד ישראלי, 10 ספרות שמתחילות ב-05.',
      missing_name: 'צריך שם פרטי ושם משפחה.',
      missing_city: 'צריך עיר מגורים.',
      missing_consent: 'כדי לשלוח, צריך לאשר את שמירת הפרטים.',
      job_not_found: 'המשרה הזו כבר לא פעילה. חזרו לרשימת המשרות ובחרו אחרת.',
      job_lookup_failed: 'יש בעיה זמנית אצלנו. נסו שוב בעוד כמה דקות.',
      cv_too_large: 'הקובץ גדול מדי. עד ' + (maxBytes / 1024 / 1024) + 'MB.',
      cv_type: 'סוג הקובץ לא נתמך. PDF, Word או תמונה.',
      rate_limited: 'שלחתם כמה פעמים. נסו שוב בעוד שעה.',
      store_failed: 'לא הצלחנו לשמור. נסו שוב, ואם זה חוזר, כתבו לנו.',
    };

    function setStatus(text, tone) {
      if (!statusEl) return;
      statusEl.textContent = text || '';
      if (tone) { statusEl.setAttribute('data-tone', tone); } else { statusEl.removeAttribute('data-tone'); }
    }

    function fieldOf(name) { return form.querySelector('[name="' + name + '"]'); }

    // Clean the phone as it is typed rather than refusing it afterwards. People
    // paste numbers with hyphens, spaces and a +972 country code, and every one of
    // those is a correct number typed by someone who should not be sent back to
    // fix formatting. 972 or +972 at the front becomes a leading 0.
    var phoneEl = fieldOf('phone');
    if (phoneEl) {
      phoneEl.addEventListener('input', function () {
        var digits = (phoneEl.value || '').replace(/\D/g, '');
        if (digits.indexOf('972') === 0) digits = '0' + digits.slice(3);
        digits = digits.slice(0, 10);
        if (digits !== phoneEl.value) phoneEl.value = digits;
      });
    }

    function markInvalid(name) {
      var el = fieldOf(name);
      if (!el) return;
      el.setAttribute('aria-invalid', 'true');
      el.focus();
    }

    function clearInvalid() {
      form.querySelectorAll('[aria-invalid]').forEach(function (el) { el.removeAttribute('aria-invalid'); });
    }

    function readFile(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          var result = String(reader.result || '');
          var comma = result.indexOf(',');
          resolve({ filename: file.name, mimeType: file.type, base64: comma === -1 ? '' : result.slice(comma + 1) });
        };
        reader.onerror = function () { reject(new Error('read')); };
        reader.readAsDataURL(file);
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearInvalid();
      setStatus('');

      var first = (fieldOf('first_name').value || '').trim();
      var last = (fieldOf('last_name').value || '').trim();
      var phone = (fieldOf('phone').value || '').trim();
      var city = (fieldOf('city').value || '').trim();
      var consent = fieldOf('consent').checked;

      if (!first) { setStatus(MESSAGES.missing_name, 'error'); markInvalid('first_name'); return; }
      if (!last) { setStatus(MESSAGES.missing_name, 'error'); markInvalid('last_name'); return; }
      // An Israeli mobile, because that is how this team reaches candidates and a
      // landline would sit in the sheet looking valid and never be answered.
      // Checked against the cleaned value, so a pasted +972 or 050-123-4567 has
      // already been normalised by the input handler above.
      if (!/^05\d{8}$/.test(phone)) { setStatus(MESSAGES.bad_phone, 'error'); markInvalid('phone'); return; }
      if (!city) { setStatus(MESSAGES.missing_city, 'error'); markInvalid('city'); return; }
      if (!consent) { setStatus(MESSAGES.missing_consent, 'error'); markInvalid('consent'); return; }

      var file = fileInput && fileInput.files && fileInput.files[0];
      if (file && file.size > maxBytes) { setStatus(MESSAGES.cv_too_large, 'error'); markInvalid('cv'); return; }

      var payload = {
        job: fieldOf('job').value,
        first_name: first,
        last_name: last,
        phone: phone,
        email: (fieldOf('email').value || '').trim(),
        city: city,
        can_reach: fieldOf('can_reach').checked,
        over_18: fieldOf('over_18').checked,
        notes: (fieldOf('notes').value || '').trim(),
        consent: true,
        hp: (fieldOf('hp').value || ''),
        elapsed_ms: Date.now() - openedAt,
      };

      submit.disabled = true;
      setStatus('שולח...');

      var prepared = file ? readFile(file).then(function (cv) { payload.cv = cv; }) : Promise.resolve();

      prepared
        .then(function () {
          return fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
        })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            if (!res.ok || !data.ok) throw new Error(data.error || 'store_failed');
            return data;
          });
        })
        .then(function () {
          form.hidden = true;
          if (doneEl) doneEl.hidden = false;
          root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        })
        .catch(function (err) {
          submit.disabled = false;
          var code = (err && err.message) || 'store_failed';
          setStatus(MESSAGES[code] || MESSAGES.store_failed, 'error');
        });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
